import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Uw bestelling (kosten per maand)',
    main: 'Uw abonnement',
    billing_settings: 'Factuurinstellingen',
  },
  form: {
    billing_mode: {
      label: 'Factureringsmodus',
    },
    has_trial: {
      label: 'Gratis proefdagen toevoegen',
    },
    trial_days: {
      label: 'Hoeveel proefdagen moeten er zijn?',
      placeholder: '21',
      validation: {
        required: 'Proefdagen is verplicht',
        min: '{{value}} is de minimale waarde voor de proefdagen',
        max: '{{value}} is de maximale waarde voor de proefdagen',
      },
    },
  },
  fields: {
    created_at: 'Aangemaakt op <strong>{{date}}</strong> door <strong>{{manager}}</strong>',
    updated_at: 'Laatst bijgewerkt op <strong>{{date}}</strong> door <strong>{{manager}}</strong>',
    trial_ends_at: 'In proefperiode tot <strong>{{date}}</strong>',
    trial_days:
      '{{trialDays}} dagen proefperiode begint op de lanceerdatum, u wordt gefactureerd wanneer de proefperiode voorbij is',
    resumable_until: 'Hervat mogelijk tot <strong>{{date}}</strong>',
    ended_at: 'Beëindigd op <strong>{{date}}</strong>',
    next_bill_at: 'Volgende factuur op <strong>{{date}}</strong>',
    product: 'Product',
    quantity: 'Hoeveelheid',
    price: 'Nettoprijs',
    tax: 'Btw',
    amount: 'Bedrag',
    net: 'Netto',
    tax_percentage: 'Btw {{rate}}%',
    total: 'Totale kosten per maand',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Kosten via betaalmethode',
    [BillingMode.InternalInvoicing]: 'Kosten via omzet',
  },
  labels: {
    included: 'inbegrepen',
    sales_based_discount:
      'Er staat een artikel in het mandje met variabele prijs; de werkelijke prijs wordt berekend bij aanmaken/bijwerken van het abonnement op basis van de omzetcijfers van de afgelopen maand',
  },
  buttons: {
    edit: 'Bewerken',
    cancel: 'Annuleren',
    resume: 'Hervatten',
  },
  modals: {
    cancel_subscription: {
      title: '{{company}}-abonnement annuleren?',
      description:
        'Hiermee wordt het geselecteerde abonnement opgezegd, inclusief <strong>{{products}}</strong> (<strong>{{total}} totaalbedrag</strong>). Het abonnement kan nog worden hervat tot <strong>{{billingAnchor}}</strong> als de klant van gedachten verandert. Als het abonnement dan niet wordt hervat, moet een nieuw abonnement worden aangemaakt',
    },
    resume_subscription: {
      title: '{{company}}-abonnement hervatten?',
      description:
        'Hiermee wordt het geselecteerde abonnement hervat, inclusief <strong>{{products}}</strong>. Het restaurant wordt elke maand <strong>{{total}}</strong> in rekening gebracht, te beginnen met <strong>{{billingAnchor}}</strong>',
    },
  },
  toasts: {
    cancel_subscription:
      'Als u uw abonnement wilt opzeggen, neem dan telefonisch of per e-mail contact op met uw {{provider}}-contactpersoon. Uw contactpersoon zal het abonnement onmiddellijk voor u opzeggen.',
    failed_to_cancel_subscription:
      'Er is iets misgegaan bij het annuleren van het abonnement. Neem contact op met de technische ondersteuning',
    resume_subscription:
      'Als u uw abonnement wilt hervatten, neem dan telefonisch of per e-mail contact op met uw {{provider}}-contactpersoon. Uw contactpersoon zal het abonnement onmiddellijk voor u hervatten.',
    failed_to_resume_subscription:
      'Er is iets misgegaan bij het hervatten van het abonnement. Neem contact op met de technische ondersteuning',
  },
};
